<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading> 
<div class="container">
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <button class="btn btn-success btn-block" routerLink="/manageprofile/register your pet with us">
        Register your Pet with Us. 
      </button>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <button class="btn btn-success2 btn-block" routerLink="/manageprofile">
          Back To Profile 
        </button>
      </div>
  </div>
  <div class="row" *ngIf='petdata && petdata.length>0'>
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6"  *ngFor="let data of petdata" >
      <div class="card"style="margin-top:3%" >
          <img class="card-img-top" style="width:100%; max-height:250px" src="https://passport.petcart.in/images/petimages/{{data.image}}" alt="Card image">
        <div class="card-body">
            <p style="font-size:20px">Pet Name: {{data.pet_name}}</p> 
            
               <p style="font-size:20px">Pet Type: {{data.pet_type}} </p>

               <p style="font-size:20px" *ngIf="data.dob && data.dob!='0000-00-00'">Date of Birth: {{data.dob}}</p>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6">
               <button class="btn btn-success btn-block" routerLink="/manageprofile/petdetail/{{data.id}}">Detail</button>
            </div>
            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6">
                <button class="btn btn-success2 btn-block" (click)="deletepet(data.id)">
                  Delete
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
